import { useState } from 'react'

function ConsentModal({ onAccept, onDecline }) {
  const [showMore, setShowMore] = useState(false)

  return (
    <div className="px-5 py-4 border-b border-soft-rule">
      <p className="text-sm text-soft-ink mb-4">
        This AI assistant is experimental. Messages are sent to external API providers.
        Conversation data is retained for research, memory graph and HITL updates.
      </p>

      {showMore && (
        <div className="text-xs text-soft-dim mb-4 space-y-1">
          <p><strong>Data stored:</strong> message text, page context, timestamps.</p>
          <p><strong>Retention:</strong> up to 6 months, then purged.</p>
          <p><strong>Your rights:</strong> email jc.mugunth@gmail.com for data deletion.</p>
        </div>
      )}

      <div className="flex gap-3">
        <button
          onClick={() => onAccept()}
          className="flex-1 px-4 py-2 bg-soft-ink text-soft-bg text-sm cursor-pointer"
        >
          {showMore ? 'I understand - enable' : 'Enable'}
        </button>
        <button
          onClick={() => setShowMore(true)}
          className="flex-1 px-4 py-2 border border-soft-rule text-sm text-soft-dim cursor-pointer hover:border-soft-dim"
        >
          {showMore ? 'Cancel' : 'Read more'}
        </button>
        {!showMore && (
          <button
            onClick={onDecline}
            className="px-4 py-2 text-sm text-soft-dim cursor-pointer hover:text-soft-ink"
          >
            No thanks
          </button>
        )}
      </div>
    </div>
  )
}

export default ConsentModal
